import { render, staticRenderFns } from "./Ifis.vue?vue&type=template&id=00327f01"
import script from "./Ifis.vue?vue&type=script&lang=js"
export * from "./Ifis.vue?vue&type=script&lang=js"
import style0 from "./Ifis.vue?vue&type=style&index=0&id=00327f01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports